<div class="bc-col-12 bc-flex statusContainer">
    <bc-status [type]='tipo' [color]='colorBadge' [text]='texto' [customIcon]='icon'></bc-status>
</div>